import { CookieService as CookieServiceParent } from 'ngx-cookie-service';
import { Inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import { uuidv4 } from '~shared/utils/uuid.util';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { DOCUMENT } from '@angular/common';
import { FeatureToggleEnum, NUMBER_180 } from '~shared/constants';

@Injectable()
export class CookieService extends CookieServiceParent {
  private readonly USER_ID_COOKIE = 'cookie_user_id';
  private isNewUniqueId: boolean;

  constructor(
    private featureFlagService: ActiveFeaturesConfigcatService,
    @Inject(DOCUMENT) private documentRef: Document,
    @Inject(PLATFORM_ID) private platformIdRef: InjectionToken<Object>
  ) {
    super(documentRef, platformIdRef);

    this.featureFlagService.isFeatureEnabled(FeatureToggleEnum.FF_OPTIMIZELY_NEW_ID, false)
      .subscribe((isEnabled: boolean) => {
        this.isNewUniqueId = isEnabled
      })
  }

  public getUserId(): string {
    if (!this.isNewUniqueId) {
      return this.get('_ga').replace(/^GA[1-9][0-9]*\.[1-9][0-9]*\./, '');
    }
    let userId = this.get(this.USER_ID_COOKIE);
    if (!userId) {
      userId = uuidv4();
      this.set(this.USER_ID_COOKIE, userId, NUMBER_180); // Storage during 6 months
    }
    return userId;
  }

  public getOptimizelyUserId(): string {
    return this.getUserId()
  }

  public getCriteoRetailerId(): string {
    return this.get('rv_id');
  }
}
